module.exports = __webpack_public_path__ + "img/9e788309fd5a3ee842f24a7f03728420.png";